import {Link, Outlet, useMatch, useResolvedPath} from 'react-router-dom';
import {useSelector} from 'react-redux';
import styles from './adminAnnouncement.module.scss';
import classnames from 'classnames/bind';
import {NavTabsEnum} from 'utils/constants';
import {useVisibleSubTabs} from 'utils/useVisibleSubTabs';
import {makeSelectTabOperations} from 'redux/store/auth';
import {NewAnnouncementButton} from './components/NewAnnouncementButton';

const ANNOUNCEMENT_SUBTABS = [
  {key: 'active', to: '/dashboard/announcements', name: 'Live'},
  {
    key: 'upcoming',
    to: '/dashboard/announcements/upcoming',
    name: 'Scheduled',
  },
  {
    key: 'expired',
    to: '/dashboard/announcements/expired',
    name: 'Expired',
  },
];

const CustomLink = ({to, name}) => {
  const resolved = useResolvedPath(to);
  const match = useMatch({path: resolved.pathname, end: true});
  const cx = classnames.bind(styles);
  return (
    <Link className={cx('navLink', match ? 'activeToggle' : '')} to={to}>
      <span>{name}</span>
    </Link>
  );
};

const AnnouncementsManagement = () => {
  const {visibleSubTabs} = useVisibleSubTabs(
    NavTabsEnum.Announcements,
    ANNOUNCEMENT_SUBTABS,
  );

  const operations = useSelector(state =>
    makeSelectTabOperations(state, NavTabsEnum.Announcements),
  );

  return (
    <div className={styles.page}>
      <header className={styles.pageHead}>
        <div>
          <h1>Announcements</h1>
          <p>Popups, banners and takeovers shown to readers in the app.</p>
        </div>
        {/* One entry point for the whole page. Each tab used to carry its own
            copy of this dropdown, and each rendered its own <h1> underneath
            this one, so every screen showed the word twice. */}
        <NewAnnouncementButton disabled={!operations?.create} />
      </header>

      <nav className={styles.tabs}>
        {visibleSubTabs.map(tab => (
          <CustomLink key={tab.key} to={tab.to} name={tab.name} />
        ))}
      </nav>

      <section className={styles.panel}>
        <Outlet />
      </section>
    </div>
  );
};

export {AnnouncementsManagement};
